const cancelledEventIdsSet = new Set([
  'Little Rock_AR_2024-11-22',
  'Grand Rapids_MI_2024-11-29',
  'Knoxville_TN_2024-12-06',
  'Loveland_CO_2024-12-06',
  'Richmond_VA_2025-05-30',
  'Charlotte_NC_2025-10-03',
  'Unknown_Unknown_2025-10-24',
  'Edison_NJ_2025-12-27',
  'Pleasanton_CA_2025-12-27',
  'Rochester_NY_2026-02-14',
  'Richmond_VA_2026-02-06'
]);

export const excludeCancelledEvents = (eventIds) => {
  return eventIds.filter((id) => !cancelledEventIdsSet.has(id));
};